import { useIsDesktop } from '@shared/util/hooks';
import { UrlEditFieldDesktop } from './UrlEditFieldDesktop';
import { UrlEditFieldMobile } from './UrlEditFieldMobile';
import { UrlEditFieldProps } from './UrlEditFieldProps';

export function UrlEditField(props: UrlEditFieldProps) {
  const isDesktop = useIsDesktop();
  if (isDesktop) {
    return <UrlEditFieldDesktop {...props} />;
  } else {
    return <UrlEditFieldMobile {...props} />;
  }
}
